// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".field-form__tab[data-v-4a5419f8] {\n  padding-top: 6px;\n}\n.system-label[data-v-4a5419f8] {\n  color: #8e9cbb;\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
